<template>
  <navbar :title="t('message.garage.carDetail')" />
  <div ref="root">
    <van-dropdown-menu>
      <van-dropdown-item v-model="yearValue" :options="selectYearList" @change="onMenuChange" />
      <van-dropdown-item v-model="makeValue" :options="selectMakeList" @change="onMenuChange" />
      <van-dropdown-item v-model="modelValue" :options="selectModelList" @change="onMenuChange" />
    </van-dropdown-menu>
    <div class="table-box">
      <table class="table-info">
        <thead class="table-header">
          <tr>
            <template v-if="type === 1">
              <!-- 汽车 -->
              <th>{{ t('message.garage.Year') }}</th>
              <th>{{ t('message.garage.Make') }}</th>
              <th>{{ t('message.garage.Trim') }}</th>
              <th>{{ t('message.garage.DriveType') }}</th>
              <th>{{ t('message.garage.Note') }}</th>
            </template>
            <template v-if="type === 2">
              <!-- 摩托 -->
              <th>{{ t('message.garage.Year') }}</th>
              <th>{{ t('message.garage.Make') }}</th>
              <th>{{ t('message.garage.Model') }}</th>
              <th>{{ t('message.garage.Note') }}</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in list" :key="index">
            <template v-if="item.type === 1">
              <td>{{ item?.year }}</td>
              <td>{{ item?.make }}</td>
              <td>{{ item?.trim }}</td>
              <td>{{ item?.driveType }}</td>
              <td>{{ item?.note }}</td>
            </template>
            <template v-if="item.type === 2">
              <td>{{ item?.year }}</td>
              <td>{{ item?.make }}</td>
              <td>{{ item?.model }}</td>
              <td>{{ item?.note }}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="loading" class="loading">
      <van-loading />
    </div>
  </div>
</template>
<script setup>
import navbar from '@/components/navbar/navbar.vue'
import { getCarDetail, getCarDetailFilter } from './api'
import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useScrollParent, useEventListener } from '@vant/use'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const root = ref(null)

const selectMakeList = ref([])
const selectModelList = ref([])
const selectYearList = ref([])
const makeValue = ref(0)
const modelValue = ref(0)
const yearValue = ref(0)
const list = ref([])
const loading = ref(false)
const route = useRoute()
const scrollParent = useScrollParent(root)
const isLastPage = ref(false)

const type = computed(() => {
  return list.value[0]?.type
})
const query = route.query
const pageSize = 40
let pageNow = 0

useEventListener(
  'scroll',
  () => {
    if (loading.value || isLastPage.value) return
    getDetail()
  },
  { target: scrollParent }
)

const onMenuChange = () => {
  pageNow = 0
  isLastPage.value = false
  list.value = []
  getDetail()
}

const getDetail = () => {
  pageNow++
  const goodsId = query.goodsId
  const params = { goodsId, pageNow, pageSize }
  if (makeValue.value !== 0) {
    params.make = makeValue.value
  }
  if (modelValue.value !== 0) {
    params.model = modelValue.value
  }
  if (yearValue.value !== 0) {
    params.year = yearValue.value
  }
  loading.value = true
  getCarDetail(params).then((res) => {
    loading.value = false
    if (res.data) {
      list.value = list.value.concat(res.data.records || [])
      if (res.data.records?.length < pageSize) {
        isLastPage.value = true
      }
    }
  })
}

const getFilterDetail = () => {
  const goodsId = query.goodsId
  getCarDetailFilter({ goodsId }).then((res) => {
    if (res.data) {
      const { makeList, modelList, yearList } = res.data
      selectMakeList.value = makeList?.map((item) => ({ value: item, text: item }))
      selectMakeList.value?.unshift({ value: 0, text: t('message.garage.allMake') })
      selectModelList.value = modelList?.map((item) => ({ value: item, text: item }))
      selectModelList.value?.unshift({ value: 0, text: t('message.garage.allModel') })
      selectYearList.value = yearList?.map((item) => ({ value: item, text: item }))
      selectYearList.value?.unshift({ value: 0, text: t('message.garage.allYear') })
    }
  })
}

onMounted(() => {
  getFilterDetail()
  getDetail()
})
</script>
<style scoped lang="scss">
.table-info {
  border-collapse: collapse;
  width: 92vw;
  .table-header {
    th {
      font-size: 0.5rem;
      text-align: center;
    }
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 8px;
    text-align: left;
    font-size: 0.4rem;
  }

  th {
    background-color: #f5f7fa;
  }
}

.table-box {
  padding: 4vw;
  box-sizing: border-box;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
